module.exports = __webpack_public_path__ + "img/practise-section.992a1986.png";